import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { Tooltip } from '@shared/ui/tooltips/base';
import { UserCategoryStatus } from '@widgets/cabinet/applicationCard/types';

import { VerifiedIcon } from '@shared/icons/verified';
import { NotVerifiedIcon } from '@shared/icons/not-verified';
import { NotVerifiedYetIcon } from '@shared/icons/not-verified-yet';
import config from '@config';

interface CustomerProfileGroupProps {
  name: string;

  status: UserCategoryStatus;
}

const tooltips = {
  [UserCategoryStatus.FailedVerified]: {
    icon: NotVerifiedIcon,
    text: 'Цей статус не пройшов перевірку в держаних реєстрах.',
  },

  [UserCategoryStatus.NonVerified]: {
    icon: NotVerifiedYetIcon,
    text: 'Цей статус ще не пройшов перевірку.',
  },

  [UserCategoryStatus.SuccessfullyVerified]: {
    icon: VerifiedIcon,
    text: 'group-verified',
  },
};

export const CustomerProfileGroup: React.FC<CustomerProfileGroupProps> = ({ name, status }) => {
  const { t } = useTranslation();

  const item = tooltips[status] || null;

  return (
    <div className="flex items-center gap-x-2">
      <span className={clsx('block py-[6px] px-3 text-xs rounded-md bg-navajo')}>{t(name)}</span>

      {item && config.features.recipientGroupStatus && (
        <Tooltip content={t(item.text)}>
          <item.icon />
        </Tooltip>
      )}
    </div>
  );
};
